<template>
  <div class="message-order-status"
       :title="datetime">
    <text-string v-bind="textStringLabelIdProps" />
    <p class="time">{{ formattedTime }}</p>
  </div>
</template>

<script>
  import {formatDate} from '@/utils/dates';
  import {
    STATUS_CODES,
    ORDER_PAYMENTS,
    CANCELLED_STATUSES,
  } from '@/reference/medicine';
  import OrderMessageParserMixin from '@/mixins/messages/order-message-parser-mixin';

  export default {
    name: 'message-order-status',
    mixins: [
      OrderMessageParserMixin,
    ],
    props: {
      message: {type: Object, required: true},
    },
    data() {
      return {
        orderStatus: JSON.parse(this.message.msg),
      };
    },
    computed: {
      datetime() {
        return formatDate(this.message.date, 'MMMM D, YYYY hh:mm a');
      },
      formattedTime() {
        return formatDate(this.message.date, 'h:mm a');
      },
      isCod() {
        return this.orderStatus.paymenttype === ORDER_PAYMENTS.cod;
      },
      otherFailedStatus() {
        return this.$options.failedStatusCode
          .map(({val}) => val)
          .includes(this.orderStatus.orderstatus);
      },
      failedStatusReason() {
        const failedStatus = this.$options.failedStatusCode.find(({val}) => val === this.orderStatus.orderstatus);
        return failedStatus ? failedStatus.label : null;
      },
      textStringLabelIdProps() {
        return this.getOrderStatusUpdateLabelProps(this.orderStatus);
      },
    },
    failedStatusCode: CANCELLED_STATUSES.filter((status) => status !== STATUS_CODES.FAILED_DELIVERY),
  }
</script>

<style lang="scss">
  .message-order-status {
    border-radius: radius(medium);
    padding: space(s) space(m);
    background-color: color(gray-50);

    .time {
      font-size: font(s);
      text-align: right;
    }
  }
</style>